import React from 'react';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { Popover, PopoverBody } from 'reactstrap';
import { strip } from '../../common/utils';
import { withLocalize } from "react-localize-redux";
import classnames from "classnames";
import generatedId from '../../common/newIdGenerator';
import ReportLinkButtons from '../../common/reportLinksButtons';
import SearchLinkButton from '../../common/searchLinkButton';

import './relations.scss';

const RELATION_LINK_TYPE = {
    REPORTS: "reports",
    SEARCH: "search"
}

class RelationLink extends React.Component {
    static defaultProps = {
        placement: "right",
        type: RELATION_LINK_TYPE.REPORTS
    };

    _noConflictPopover = undefined;
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            showLinks: false,
            elementId: generatedId()
        };
    }

    toggle() {
        var isVisible = this.state.showLinks;
        this.setState({ showLinks: !this.state.showLinks });
        if (!isVisible) {
            this.autoHidePopover();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.entityId !== nextProps.entityName || this.state.isVisible !== nextState.isVisible;
    }

    render() {
        if (isNullOrUndefined(this.props.entityName))
            return null;

        if (this.props.type === RELATION_LINK_TYPE.REPORTS && (isNullOrUndefined(this.props.entityId) || isNullOrUndefined(this.props.reports) || !this.shouldDisplayLinks(this.props.reports)) ||
            this.props.type === RELATION_LINK_TYPE.SEARCH && (isNullOrUndefined(this.props.query)))
            return <div className='rel-link-box'><span className='rel-link'>{this.props.entityName}</span></div>

        const isDisabled = !isNullOrUndefined(this.props.disabled) && this.props.disabled === true;

        return (<>
            <div ref={el => this.relLinkBox = el} className={"rel-link-box"}>
                {this.props.customPrefix}
                <span
                    className={classnames('link-functional rel-link', { 'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile, 'disabled': isDisabled, 'historical': this.props.historical === true })}
                    onClick={this.toggle}
                    ref={el => this.relLink = el}
                    title={strip(this.props.entityName)}
                    id={this.state.elementId}
                    style={this.props.spanStyle}
                >
                    {this.props.entityName}
                </span>

                {!isDisabled && this.renderLinks()}
            </div>
        </>)
    }

    shouldDisplayLinks = (reports) => {
        let { GR, RP, RD } = reports
        return GR || RP || RD;
    }

    renderLinks = () => {
        return (<>
            <Popover onMouseLeave={() => this.hidePopover()} onMouseOver={() => this.keepPopoverVisible()} placement={this.props.placement} isOpen={this.state.showLinks} toggle={this.toggle} target={this.state.elementId}>
                <PopoverBody>
                    <div className="relation-dropdown-name hide-on-desktop">
                        {this.props.entityName}
                    </div>
                    <div className="relation-dropdown-menu">
                        {this.props.type === RELATION_LINK_TYPE.REPORTS && <ReportLinkButtons translate={this.props.translate} entityId={this.props.entityId} reports={this.props.reports} includeQuickReport={true} openNewWindow={true}
                            extraClass='with-vertical-margin' column />}
                        {this.props.type === RELATION_LINK_TYPE.SEARCH && <SearchLinkButton translate={this.props.translate} query={this.props.query} openNewWindow={true} 
                            extraClass='with-vertical-margin' column />}
                    </div>
                </PopoverBody>
            </Popover>
        </>)
    }

    handleScroll = () => {
        if (this.state.showLinks) {
            this.setState({ showLinks: false });
        }
    }

    autoHidePopover = () => {
        this._noConflictPopover = window.setTimeout(() => this.setState({ showLinks: false }), 1500);
    }

    keepPopoverVisible = () => {
        if (this._noConflictPopover !== undefined && this._noConflictPopover !== null) {
            window.clearTimeout(this._noConflictPopover);
        }

    }

    hidePopover = () => {
        if (this._noConflictPopover !== undefined && this._noConflictPopover !== null) {
            window.clearTimeout(this._noConflictPopover);
            this._noConflictPopover = undefined;
        }

        window.setTimeout(() => this.toggle(), 250);
    }
}

export default withLocalize(RelationLink);